module.exports = __webpack_public_path__ + "static/img/Aquarius.b7b475c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image/Aquarius.svg
// module id = 1394
// module chunks = 0